<template>
    <div class="view-refund">
        <div>
        <v-row class="mx-3">
            <v-col class="text-left">
            <v-checkbox v-model="printTwoCopies" label="Print 2 Copies"></v-checkbox>
            </v-col>
            <v-col class="text-right">
            <v-btn v-if="!isLoading" @click="printPdf">Print</v-btn>
            <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
            </v-col>
        </v-row>

        <FeeRefundTable :receipt="receipt" :copyName="`${printTwoCopies ? 'OFFICE COPY' : ''}`" />
        <FeeRefundTable v-if="printTwoCopies" :receipt="receipt" :copyName="`${printTwoCopies ? 'PARENT COPY' : ''}`" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import FeeRefundTable from "@components/fees/FeeRefundTable.vue";

export default {
    name: 'ViewRefund',
    data(){
        return{
            receipt: null,
            printTwoCopies: false,
        };
    },
    components: {
        FeeRefundTable,
    },
    computed: {
        ...mapGetters([
            "currentUser",
            "currentInstitution",
            "accessToken",
            "isLoading",
        ]),
        essentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
    },
    methods: {
        ...mapActions(["setLoading"]),
    async getReceiptData() {
      this.receipt = await api.call(
        this.essentials,
        endpoints.getFeeReundReceiptDetails + this.$route.params.rid + "/"
      );
    },

    async printPdf() {
        var windowOptions =
            "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=1024,height=768";
        window.open(
            "/fees/records/students/refund/receipt/print/" +
            this.$route.params.sid +
            "/" +
            this.$route.params.rid +
            "/" +
            (this.printTwoCopies ? "2" : "1"),
                "Print Receipt",
                windowOptions
            );
        },

    
    },
    created(){
        this.getReceiptData();
    }
}
</script>